import React from "react";
import Sidebar from "./Sidebar";

export default function DashboardShell({ role, pageTitle, children }) {
  const date = new Intl.DateTimeFormat("en-US", {
    weekday: "short", month: "short", day: "numeric", year: "numeric",
  }).format(new Date());

  return (
    <div className="tw-flex tw-h-[calc(100vh-5rem)] tw-overflow-hidden tw-bg-[#1E0039]">
      <div className="tw-flex tw-flex-1 tw-overflow-hidden tw-pt-3 tw-pb-4 tw-px-3">
        <Sidebar role={role} />
        <main className="tw-flex-1 tw-overflow-hidden tw-p-6 tw-flex tw-flex-col">
          {pageTitle && (
            <header className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3 tw-mb-4 tw-bg-[#280D41] tw-rounded-xl tw-border tw-border-white/10 tw-shrink-0">
              <h1 className="tw-text-white tw-font-semibold tw-text-lg tw-m-0">{pageTitle}</h1>
              <p className="tw-hidden sm:tw-block tw-text-sm tw-text-white/50 tw-m-0">{date}</p>
            </header>
          )}
          <div className="tw-flex-1 tw-min-h-0 tw-overflow-auto tw-pb-20 md:tw-pb-0">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
